<template>
  <div style="width: 100%;height: 100%;position: relative;border: 1px solid #dedede;padding: 5px 10px">
    <el-button type="info" icon="el-icon-full-screen" circle @click="setFullScreen"
               style="color:#FFFFFF;position: absolute;bottom:15px;right: 15px;z-index: 1"></el-button>
    <el-button type="info" icon="el-icon-arrow-up" class="upCircle" @click="controlVideo('UP')"
               style="color:#FFFFFF;position: absolute;top:9px;right: 50%;z-index: 1"></el-button>
    <el-button type="info" icon="el-icon-arrow-down" class="downCircle" @click="controlVideo('DOWN')"
               style="color:#FFFFFF;position: absolute;bottom:8px;right: 50%;z-index: 1"></el-button>
    <el-button type="info" icon="el-icon-arrow-left" class="leftCircle" @click="controlVideo('LEFT')"
               style="color:#FFFFFF;position: absolute;bottom:40%;left: 1px;z-index: 1"></el-button>
    <el-button type="info" icon="el-icon-arrow-right" class="rightCircle" @click="controlVideo('RIGHT')"
               style="color:#FFFFFF;position: absolute;bottom:40%;right: 10px;z-index: 1"></el-button>
    <video
        :id="videoId"
        style="width: 100%; height: 100%"
        class="video-js vjs-hidden"
    ></video>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'
// import 'video.js/dist/video-js.css'

export default {
  name: "VideoComp",
  props: {
    // 视频地址、video的id值
    vData: {
      type: Object,
      default: () => {
        return {
          hlsurl: '', // 视频url地址
          cameraId: '', // id
          deviceCode: ''
        }
      }
    }
  },
  data() {
    return {
      options: {
        autoplay: 'any', // 设置自动播放
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: false, // 显示播放的控件
        language: 'zh-CN', // 设置语言
        // muted: false, // 是否静音
        // inactivityTimeout: false,
        // controlBar: {
        //   // 设置控制条组件
        //   // /* 设置控制条里面组件的相关属性及显示与否*/
        //   // 'currentTimeDisplay':true,
        //   // 'timeDivider':true,
        //   // 'durationDisplay':true,
        //   // 'remainingTimeDisplay':false,
        //   // volumePanel: {
        //   //   inline: false
        //   // }
        //   /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
        //   children: [
        //     {name: 'playToggle'}, // 播放按钮
        //     {name: 'currentTimeDisplay'}, // 当前已播放时间
        //     {name: 'progressControl'}, // 播放进度条
        //     {name: 'durationDisplay'}, // 总时间
        //     { // 倍数播放
        //       name: 'playbackRateMenuButton',
        //       'playbackRates': [0.5, 1, 1.5, 2, 2.5]
        //     },
        //     {
        //       name: 'volumePanel', // 音量控制
        //       inline: false, // 不使用水平方式
        //     },
        //     {name: 'FullscreenToggle'} // 全屏
        //   ]
        // },
      },
      player: null,
      videoId: '',
      isFullscreen: false
    }
  },
  methods: {
    getVideo(nowPlayVideoUrl, nowPlayVideoId) {
      this.player = videojs(nowPlayVideoId, this.options)
      // 关键代码， 动态设置src，才可实现换台操作
      // 不动态设置依然也可以这样写
      this.player.src([
        {
          src: nowPlayVideoUrl,
          type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
        }
      ])

      this.player.on('fullscreenchange', function (e) {
        // console.log(e);
      });
    },
    setFullScreen() {
      // 进入全屏模式
      this.player.requestFullscreen();
    },
    controlVideo(ptzCmd) {
      //开始
      let action = 0
      this.accessToken = localStorage.getItem("tyToken")
      this.$http.post(`/api/tysl/deviceControl`, {
        accessToken: this.accessToken,
        deviceCode: this.deviceCode,
        action: action,
        ptzCmd: ptzCmd,
        speed: 100
      }).then(res => {
        console.log(0)
        if (res.data.status === '200') {
          // 停止
          action = 1
          this.$http.post(`/api/tysl/deviceControl`, {
            accessToken: this.accessToken,
            deviceCode: this.deviceCode,
            action: action,
            ptzCmd: ptzCmd,
            speed: 100
          }).then(res => {
            console.log(1)
            if (res.data.status === '200') {
            }
          })
        }
      })
    }
  },
  watch: {
    // 监听视频地址、video的id值
    vData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.videoId = val.cameraId
        this.deviceCode = val.deviceCode
        this.$nextTick(() => {
          this.getVideo(val.hlsurl, val.cameraId)
        })
      }
    }
  },
  beforeDestroy() {
    //  组件销毁时，清除播放器
    if (this.player) {
      this.player.dispose() // 该方法会重置videojs的内部状态并移除dom
    }
  }
}
</script>

<style scoped lang="less">
:deep(.video-js .vjs-big-play-button) {
  display: none;
}

:deep(.video-js .vjs-text-track-display) {
  display: none;
}

:deep(.video-js .vjs-loading-spinner) {
  display: none;
}

:deep(.video-js .vjs-control-bar) {
  display: none;
}

:deep(.video-js .vjs-error-display) {
  display: none;
}

:deep(.video-js .vjs-modal-dialog) {
  display: none;
}

.upCircle {
  border-radius: 0px 0px 50% 50% !important;
  height: 20px !important;
  width: 30px !important;
  padding: 0px !important;
}

.downCircle {
  border-radius: 50% 50% 0px 0px !important;
  height: 20px !important;
  width: 30px !important;
  padding: 0px !important;
}

.leftCircle {
  border-radius: 0px 50% 50% 0px !important;
  height: 30px !important;
  width: 20px !important;
  padding: 0px !important;
}

.rightCircle {
  border-radius: 50% 0px 0px 50% !important;
  height: 30px !important;
  width: 20px !important;
  padding: 0px !important;
}
</style>
